The identifier of the `DraftPosition`.

This draft position profile can be queried by passing this identifier string to `publicDraftPositionProfile`.
